module.exports = __webpack_public_path__ + "img/quotes.5b7c59d.svg";